import axios from 'axios';

/**
 * Server query params is an object that handles these keys:
 *  - url         relative url to call
 *  - parameters  url paramaters
 *  - data        data to send
 *  - onSuccess   function to call on success
 *  - onError     function to call on error
 */

export default {
  data: () => ({
    server_$requests: 0,
  }),

  computed: {
    server_loading: function() { return this.server_$requests > 0; },
  },

  methods: {
    /**
     * Return server url for given values.
     * @param {string} base servere base url
     * @param {string} url relative url
     * @param {object} parameters parameters
     * @return {string} server url
     */
    server_url: function(base, url, parameters) {
      const uri = [ base, url ];

      if (parameters) {
        for (const key in parameters) {
          uri.push(key);
          uri.push(encodeURIComponent(parameters[key]));
        }
      }

      return uri.join('/');
    },

    /**
     * Return full server url.
     * @param {string} url url
     * @param {object} parameters parameters
     * @return {string} server url
     */
    server_fullUrl: function(url, parameters) {
      return this.server_url(process.env.VUE_APP_SERVER_BASE_FULL_URL, url, parameters);
    },

    /**
     * Retrive data from server.
     * @param {object} queryParams query parameters
     */
    server_query: function(queryParams) { this.server_doQuery('get', queryParams); },

    /**
     * Call server command.
     * @param {object} queryParams query parameters
     */
    server_execute: function(queryParams) { this.server_doQuery('get', queryParams); },

    /**
     * Delete data on the server.
     * @param {object} queryParams query parameters
     */
    server_delete: function(queryParams) { this.server_doQuery('delete', queryParams); },

    /**
     * Save data to the server.
     * @param {object} queryParams query parameters
     */
    server_save: function(queryParams) { this.server_doQuery('post', queryParams); },

    /**
     * Send data to the server.
     * @param {object} queryParams query parameters
     */
    server_send: function(queryParams) { this.server_doQuery('post', queryParams); },

    /**
     * Update data on the server.
     * @param {object} queryParams query parameters
     */
    server_update: function(queryParams) { this.server_doQuery('put', queryParams); },

    /**
     * Upload file on the server.
     * @param {object} queryParams query parameters
     */
    server_upload: function(queryParams) {
      if (queryParams && 'data' in queryParams && queryParams.data) {
        const data = queryParams.data;

        queryParams.headers = { 'Content-Type': 'multipart/form-data' };
        queryParams.data = Object.keys(data).reduce((formData, key) => {
          formData.append(key, data[key]);
          return formData;
        }, new FormData());
      }

      this.server_doQuery('post', queryParams);
    },

    /**
     * Query the server.
     * @param {string} method query method
     * @param {object} queryParams query parameters
     */
    server_doQuery: function(method, queryParams) {
      // Check parameters
      if (typeof method !== 'string' || !method)
        throw 'ERROR: server_doQuery - missing method';
      else if (typeof queryParams !== 'object' || !queryParams)
        throw 'ERROR: server_doQuery - missing query parameters';
      else if ('url' in queryParams === false || !queryParams.url)
        throw 'ERROR: server_doQuery - missing query url';

      const config = {
        method: method,
        url: this.server_url(process.env.VUE_APP_SERVER_BASE_URL, queryParams.url, queryParams.parameters),
        data: queryParams.data
      };

      // Add additional parameters for the query
      'headers' in queryParams && (config.headers = queryParams.headers);

      this.server_$requests++;
      axios(config).then((response) => {
        this.server_$requests--;

        if (typeof queryParams.onSuccess === "function") {
          queryParams.onSuccess(response.data);
        }
      }).catch((error) => {
        this.server_$requests--;

        if (typeof queryParams.onError !== "function" || !queryParams.onError(error.response)) {
          // Catch forbidden access or save last error
          if (error.response && error.response.status === 403) {
            this.$router.push('/login')
          } else {
            this.$store.commit('addMessage', {
              type: 'error',
              text: (error.response && error.response.data) ? `${error} - ${error.response.data}` : error
            });
          }
        }
      });
    },
  }
};

